import { EAdminMercadoPagoQueryType } from "../../Enum/EAdminMercadoPagoQueryType"

export class AdminMercadoPagoQuery {
  queryType: EAdminMercadoPagoQueryType

  resourceId: string

  constructor(data: Partial<AdminMercadoPagoQuery> = {}) {
    this.queryType = data.queryType ?? EAdminMercadoPagoQueryType.Payment

    this.resourceId = data.resourceId ?? ""
  }
}
